module.exports = __webpack_public_path__ + "img/t2-26.efdad9a9.svg";